export default "__VITE_ASSET__DcHmN7d8__"